import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { CONSENT_KEY, getConsent, loadAnalytics } from "@/lib/tracking";

export const openCookiePrefs = () => window.dispatchEvent(new Event("sl-cookie-open"));

export const CookieBanner = () => {
  const [open, setOpen] = useState(() => !getConsent());

  useEffect(() => {
    const h = () => setOpen(true);
    window.addEventListener("sl-cookie-open", h);
    return () => window.removeEventListener("sl-cookie-open", h);
  }, []);

  const choose = (v) => {
    localStorage.setItem(CONSENT_KEY, v);
    setOpen(false);
    if (v === "all") loadAnalytics();
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 40, opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-3 bottom-3 z-[70] mx-auto max-w-2xl rounded-2xl border border-line bg-[#120e08]/90 p-5 backdrop-blur-xl sm:p-6"
        >
          <p className="text-sm leading-relaxed text-cream">
            Usiamo cookie tecnici e, solo con il tuo consenso, cookie di analisi e marketing (Meta Pixel e Google Analytics) per misurare le campagne.{" "}
            <Link to="/privacy" className="text-gold-light underline underline-offset-4" data-testid="cookie-privacy-link">Informativa privacy</Link>
          </p>
          <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:justify-end">
            <button type="button" className="btn-ghost" onClick={() => choose("necessary")} data-testid="cookie-necessary-btn">Solo necessari</button>
            <button type="button" className="btn-gold !py-3" onClick={() => choose("all")} data-testid="cookie-accept-btn">Accetta tutti</button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
